import { Component } from "../../../../component-decorator";
import { PrintLabelController } from "../../../../components/print/print-label.controller";

@Component({
  bindings: {
    pedido: "<",
  },
  componentName: "appHistoricoPedidoTabela",
  controllerAs: "$ctrl",
  template: require("./historico-tabela.html"),
})
export class HistoricoTabelaComponent implements angular.IController {
  public alerts = [];
  public buscarPor = null;
  public checkboxes = { checked: false, items: {} };
  public currentPage = 1;
  public freedom = false;
  public pedido;
  public searchObject: any = {};
  public searching = false;
  public tableBasic;

  private print: PrintLabelController;

  constructor(private $scope, private NgTableParams, Pedido, private Perfil) {
    "ngInject";

    this.print = new PrintLabelController(Pedido);
  }

  $onInit() {
    this.buildTable();

    this.freedom = this.Perfil.getCacheUserData().freedom;
  }

  async printLabels(orders) {
    if (!this.print.hasSelected(this.$scope.checkboxes, {})) {
      this.addAlert(
        "Selecione as encomendas antes de imprimir suas etiquetas.",
        "danger"
      );
    } else {
      await this.print.getLabelsToPrint(orders, null);
      this.$scope.exibirSituacaoPedido(this.pedido.id);
    }
  }

  addAlert(msg, type) {
    this.alerts.push({ msg, type });
  }

  closeAlert(index) {
    this.alerts.splice(index, 1);
  }

  clearSearch() {
    this.searchObject = {};
  }

  changeFilter() {
    this.resetSelectLabels();
    this.tableBasic.filter(Object.assign({}, this.searchObject));
  }

  clearFilter() {
    this.resetSelectLabels();
    this.tableBasic.filter({});
    this.searchObject = {};
    this.buscarPor = null;
  }

  isEmpty() {
    if (this.tableBasic.data) {
      return !this.print.hasSelected(
        this.checkboxes,
        this.tableBasic.data.length
      );
    }

    return true;
  }

  selectAll() {
    this.checkboxes = this.print.toggleSelectAll(
      this.checkboxes,
      this.tableBasic.data,
      false
    );
  }

  pageUpdate() {
    this.resetSelectLabels();
  }

  private buildTable() {
    this.tableBasic = new this.NgTableParams(
      {
        page: 1,
        count: 50,
        sorting: {
          name: "desc",
        },
      },
      {
        counts: [50, 100],
        total: this.pedido ? this.pedido.remessas.length : 0,
        dataset: this.pedido ? this.pedido.remessas : [],
      }
    );
  }

  private resetSelectLabels() {
    this.checkboxes = this.print.toggleSelectAll(
      this.checkboxes,
      this.tableBasic.data,
      true
    );
  }
}
